import PropTypes from 'prop-types';
import { useMemo } from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';

const ltrCache = createCache({ key: 'mui-color-input-ltr' });

MuiColorInputLtrWrapper.propTypes = {
  children: PropTypes.node,
};

export default function MuiColorInputLtrWrapper({ children }) {
  const theme = useTheme();
  const ltrTheme = useMemo(() => createTheme({ ...theme, direction: 'ltr' }), [theme]);

  return (
    <CacheProvider value={ltrCache}>
      <ThemeProvider theme={ltrTheme}>
        <div dir="ltr" style={{ direction: 'ltr' }}>{children}</div>
      </ThemeProvider>
    </CacheProvider>
  );
}
